require('./angular-cookies');
module.exports = 'ngCookies';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-cookies/index.js
 ** module id = 673
 ** module chunks = 8
 **/